import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll-to"
export default class extends Controller {
	// A feed the page scrolls itself (the hub's Rolagens box) opts out, so a roll never moves the page.
	connect() {
		if (this.element.closest("[data-no-scroll-to]")) return;
		this.element.scrollIntoView();
	}
}
